<template>
  <section id="dashboard">
    <b-row class="match-height">
      <b-col lg="12" sm="12">
        <home-info-abatedor />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col lg="12" sm="12">
        <home-info-general />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col lg="12" sm="12">
        <!-- Component das tabs comentado -->
        <home-info-devices />
        <!-- <home-info-device-total /> -->
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";
import HomeInfoAbatedor from "./HomeInfoAbatedor.vue";
import HomeInfoGeneral from "./HomeInfoGeneral.vue";
import HomeInfoDevices from "./HomeInfoDevices.vue";
import HomeInfoDeviceTotal from "./HomeInfoDeviceTotal.vue";

export default {
  components: {
    BRow,
    BCol,
    HomeInfoAbatedor,
    HomeInfoGeneral,
    HomeInfoDevices,
    HomeInfoDeviceTotal,
  },
  data() {
    return {
      data: {},
    };
  },
  created() {
    this.$store.dispatch("devices/getRegisteredDevices", { context: this });
    this.$store.dispatch("recipes/getRecipes", { context: this });
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-home.scss";
</style>
